<template>
  <div>
    <div class="banner666">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082807390745.jpg"></el-image>
      <div class="cover">
        <h1>手套分类</h1>
        <div class="subtitle">健康手套</div>
      </div>
    </div>
    <div class="module">
      <el-row>
        <el-col :span="14">
          <div class="content">
            <div>
              <div class="title">
                设计手部健康防护的未来
              </div>
              <div class="desc">
                我们提供各种高品质的天然胶乳和丁腈橡胶检查手套及通用一次性手套。凭借丰富的专业知识和大量研发，诗董手套在质量和竞争力方面延续一贯的高标准。产品为亚洲人手型设计，更好地贴合手部曲线，可有效缓解手部工作疲劳。我们在质量和竞争力方面为自己树立了高标准，以实现在全球范围˹美好生活触手可及˼的愿景。
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="10" style="display: flex;justify-content: flex-end;">
          <el-image src="/img/st1.jpg"></el-image>
        </el-col>
      </el-row>
    </div>
    <div class="module">
      <el-row>
        <el-col :span="10" style="display: flex;justify-content: flex-start;">
          <el-image src="/img/st2.jpg"></el-image>
        </el-col>
        <el-col :span="14">
          <div class="content">
            <div>
              <div class="title">
                一次性乳胶有粉手套
              </div>
              <div class="desc">
                乳胶有粉手套已诞生100多年。乳胶有粉手套和最初生产时比已有所改进。泰国自产优势天然乳胶原料，弹性佳。我们对天然乳胶原料的了解和研发以及手套生产的经验。可吸收玉米粉，容易穿戴且安全可靠。优越的触感灵敏度，抓握度更佳。低手部束缚感，手部操作更加灵活。
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="module">
      <el-row>
        <el-col :span="14">
          <div class="content">
            <div>
              <div class="title">
                一次性乳胶无粉手套
              </div>
              <div class="desc">
                泰国自产优势天然乳胶原料，弹性佳。不含粉末残留，采用先进的线上过氯/涂层工艺，降低致敏性，它为用户提供更舒适的触感，无任何粉末残留物，提供高水平的舒适度与安全保障。
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="10" style="display: flex;justify-content: flex-end;">
          <el-image src="/img/st3.jpg"></el-image>
        </el-col>
      </el-row>
    </div>
    <div class="module">
      <el-row>
        <el-col :span="10" style="display: flex;justify-content: flex-start;">
          <el-image src="/img/st4.jpg"></el-image>
        </el-col>
        <el-col :span="14">
          <div class="content">
            <div>
              <div class="title">
                一次性丁腈橡胶手套
              </div>
              <div class="desc">
                不含可能引起过敏反应的乳胶蛋白成分。耐酸碱、耐穿刺、防静电，具有更好的防护性。拥有优于市面上多数同类产品的舒适度与弹性。
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="info">我们的手套适用于医疗、护理、科研以及其他需要良好卫生标准和手部防护的工业和服务领域。</div>
    <div class="category" v-for="(item,index) in gloveCategories" :key="index">
      <h2>{{ item.name }}</h2>
      <div class="list">
        <el-row :gutter="20">
          <el-col :span="3" v-for="(item2,index1) in getList(item)" :key="index1">
            <div class="item">
              <div class="img">
                <el-image :src="item2.coverUrl"></el-image>
              </div>
              <div class="name">{{ item2.name }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="certification"
         style="background: url('https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082810043951.jpg') no-repeat; background-size: 100% 100%;">
      <el-row>
        <el-col :span="12">&nbsp;</el-col>
        <el-col :span="12">
          <div class="section-hd">
            <h2>标准及认证</h2>
          </div>
          <div class="list">
            <el-row :gutter="20">
              <el-col :span="6" class="item" v-for="(item,index) in certificationList" :key="index">
                <el-image :src="item.coverUrl"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getGloveCategoryIndex} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      gloveCategories: null,
      list: null,
      advBanner: null,
      advCertification: null,
      certificationList: null,
    }
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getGloveCategoryIndex().then((res) => {
        this.gloveCategories = res.data.gloveCategories;
        this.list = res.data.list;
        this.advBanner = res.data.advBanner;
        this.advCertification = res.data.advCertification;
        this.certificationList = res.data.certificationList;
      })
    },
    getList(t) {
      let data = [];
      for (let i = 0; i < this.list.length; i++) {
        let item = this.list[i];
        if (t.categoryNo == item.categoryNo) {
          data.push(item);
        }
      }
      return data;
    }
  }
}
</script>

<style scoped>
@import url("Index.css?v=100");
</style>
